module.exports = __webpack_public_path__ + "img/Small-Semi-Elliptical-Attachment-L-12.daa34648.png";